export default __webpack_public_path__ + "static/media/smart-schedule-1.a40ea26b.png";